module.exports = __webpack_public_path__ + "img/181606188304_.pic_hd.acc4f0e5.jpg";